module.exports = __webpack_public_path__ + "static/media/17.3f3e797c.jpg";